import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppApiService, CommunicationsApiService } from '@shared/core';
import { convertApiItemResponseToItem, convertApiResponseToPaginable } from '@shared/core/utils';
import { DEFAULT_REQUEST_PARAMS } from '@shared/core/types';
import {
  NotificationItemList,
  NotificationItemListResponse,
  NotificationsUnreadCount,
  NotificationsUnreadCountResponse,
} from '../types';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class VimbotNotifierApiService {
  protected baseEndpoint = environment.communications.host + '/gateway/widget/vimbot/notifications';

  constructor(protected api: AppApiService) {}

  getCount(): Observable<NotificationsUnreadCount> {
    return this.api.get<NotificationsUnreadCountResponse>(`${this.baseEndpoint}/count`).pipe(
      convertApiItemResponseToItem,
      map(data => data.count),
      catchError(() => of(null)),
    );
  }

  getNotifications(page?: number): Observable<NotificationItemList> {
    return this.api
      .get<NotificationItemListResponse>(`${this.baseEndpoint}`, {
        params: {
          page,
        },
        ...DEFAULT_REQUEST_PARAMS,
      })
      .pipe(convertApiResponseToPaginable);
  }
}
